import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { HrDashboardService } from '../../service/hr-dashboard/hr-dashboard.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-hr-claim-status',
  templateUrl: './hr-claim-status.component.html',
  styleUrls: ['./hr-claim-status.component.scss']
})
export class HrClaimStatusComponent implements OnInit {

  inputForm = this.fb.group({
    groupPolicyId: [null, [Validators.required]],
    policyYear: [null, [Validators.required]],
    claimTypePrefix: [null, [Validators.required]]
  });

  gmTypePrefixId: number;
  glTypePrefixId: number;

  groupPolicyHr: any = [];
  policyYears: any = []

  reportLifeAndDisability: any = []
  reportGroupMedical: any = []

  chart: any = null;

  constructor(private fb: FormBuilder,
    private enumService: EnumService,
    private hrDashboardService: HrDashboardService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.getAllGroupPolicyByHr();
    this.getClaimTypePrefixes();

    this.inputForm.get('groupPolicyId').valueChanges.subscribe(() => {
      this.inputForm.get("policyYear").setValue(null)
      this.inputForm.get("claimTypePrefix").setValue(null)
      this.getPolicyYears()
    })

    this.inputForm.get('policyYear').valueChanges.subscribe(() => {
      this.inputForm.get("claimTypePrefix").setValue(null)
      if (this.inputForm.valid) {
        this.getReport(this.inputForm.get('claimTypePrefix').value)
      }
    })
  }

  getClaimTypePrefixes() {
    this.enumService.getClaimTypePrefixNumber().subscribe(res => {
      res.forEach(x => {
        if (x.value == "GL") {
          this.glTypePrefixId = x.id
        }
        else if (x.value == "GM") {
          this.gmTypePrefixId = x.id
        }
      })
    })
  }

  getAllGroupPolicyByHr() {
    this.hrDashboardService.getGroupPolicyByHrUser().subscribe(res => {
      this.groupPolicyHr = res;
    }, err => {
      this.messageService.show(err.error.message, 'error');
    });
  }

  getPolicyYears() {
    let groupPolicyId = this.inputForm.get('groupPolicyId').value

    this.hrDashboardService.getLastTwoAnniversariesByGroupPolicy(groupPolicyId).subscribe(res => {
      this.policyYears = res;
    }, err => {
      this.messageService.show(err.error.message, 'error');
    });
  }

  getReport(claimTypePrefixId: number) {
    let groupPolicyId = this.inputForm.get('groupPolicyId').value
    let anniversaryId = this.inputForm.get('policyYear').value
    this.resetChart()

    this.reportLifeAndDisability = []
    this.reportGroupMedical = []

    if (groupPolicyId && anniversaryId) {
      this.hrDashboardService.getReport(groupPolicyId, anniversaryId, claimTypePrefixId).subscribe(res => {
        if (claimTypePrefixId == this.glTypePrefixId) {
          this.reportLifeAndDisability = res.hrDashboardClaimsReports
        }
        else {
          this.reportGroupMedical = res.hrDashboardClaimsReports
        }
        this.createChart()
      }, err => {
        this.messageService.show(err.error.message, 'error');
      });
    }
  }

  resetChart() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  createChart() {
    this.resetChart()
    if (this.reportGroupMedical && this.reportGroupMedical.length) {
      let amounts = this.reportGroupMedical.map(x => x.amount)
      let months = this.reportGroupMedical.map(x => x.month.substring(0, 3) + " " + x.year)

      if (amounts && months) {
        this.chart = new Chart("lineChart", {
          type: 'line',
          data: {
            labels: months,
            datasets: [{
              data: amounts,
              label: "Paid Amount",
              backgroundColor: 'transparent',
              borderColor: '#A4CE4E',
              borderWidth: 3,
              lineTension: 0
            }],
          },
          options: {
            tooltips: {
              enabled: true,
              intersect: false,
              backgroundColor: '#0061A0',
              bodyColor: 'white',
              footerFont: "{weight: 'bold'}",
              displayColors: false
            },
            legend: {
              display: false
            },
            responsive: true,
            scales: {
              yAxes: [{
                gridLines: { color: '#eae8e8' },
                ticks: {
                  fontColor: "#007abc",
                  beginAtZero: true
                }
              }],

              xAxes: [{
                gridLines: { color: '#eae8e8' },
                ticks: {
                  fontColor: "#007abc",
                  beginAtZero: false
                }
              }],
            },
          }
        });
      }
    }
  }
}